<template>
  <div class="app-container">
    <h1 class="app-tit">{{ t('policy_service') }}</h1>

    <div class="head-txt-wrap">
      <strong>시행일 : 2025년 12월 22일</strong>
      <p>
        본 약관은 SconAI(이하 "회사")가 제공하는 SconChat 통역 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자
        간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>
    </div>
    <div class="marker-txt-wrap">
      <div class="txt-group">
        <h2>제 1조 (목적)</h2>
        <ul class="marker-dot">
          <li>
            본 약관은 회사가 제공하는 서비스 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사 항, 서비스 이용
            조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제2조 (용어의 정의)</h2>
        <ul class="marker-dot">
          <li>
            <div class="inr">
              <h3>이용자</h3>
              <p>회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>회원</h3>
              <p>개인정보를 제공하고 회원등록을 한 자로서 서비스를 이용할 수 있는 자를 의미합니다.</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>비회원</h3>
              <p>회원으로 가입하지 않고 서비스를 이용하는 자를 의미합니다.</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>콘텐츠</h3>
              <p>서비스 제공과 관련하여 제공되는 부호, 문자, 음성, 음향, 이미지, 영상 등 일체의 자료를 의미 합니다.</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 3조 (약관의 효력 및 변경)</h2>
        <ul class="marker-dot">
          <li>본 약관은 서비스를 이용하고자 하는 모든 이용자에게 효력을 가집니다.</li>
          <li>회사는 약관 내용을 이용자가 쉽게 알 수 있도록 웹사이트 또는 약관 동의 화면에 게시합니다.</li>
          <li>회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
          <li>
            약관이 변경되는 경우 시행일 7일 전부터 공지하며, 이용자에게 불리한 변경의 경우 30일 전 개별 통지합니다.
          </li>
          <li>이용자가 변경된 약관 시행 이후에도 서비스를 계속 이용할 경우 변경된 약관에 동의한 것으로 봅니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 4조 (서비스의 제공)</h2>
        <ul class="marker-dot">
          <li>서비스는 연중무휴 24시간 제공을 원칙으로 합니다.</li>
          <li>
            설비 점검, 장애, 운영상 필요에 따라 서비스 제공이 일시 중단될 수 있으며, 이 경우 사전 또는 사후에
            공지합니다.
          </li>
          <li>정기 점검 일정은 웹사이트 또는 서비스 화면을 통해 안내합니다.</li>
          <li>회사는 서비스의 내용 변경 또는 종료 시 사전에 공지합니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 5조 (이용자의 의무)</h2>
        <ul class="marker-dot">
          <li>이용자는 관계 법령, 본 약관, 서비스 이용 안내 및 회사의 공지 사항을 준수해야 합니다.</li>
          <li>
            <div class="inr" style="margin-top: 0.5rem">
              <h3>금지 행위</h3>
              <div class="mk-hp-wrap">
                <p class="marker-hyphen">타인의 개인정보 도용 또는 부정 사용</p>
                <p class="marker-hyphen">서비스 운영 방해 행위</p>
                <p class="marker-hyphen">회사 또는 제3자의 명예를 훼손하는 행위</p>
                <p class="marker-hyphen">음란·폭력 등 공서양속에 반하는 정보 유통</p>
                <p class="marker-hyphen">서비스의 복제, 역설계, 소스코드 추출 시도</p>
                <p class="marker-hyphen">범죄와 관련된 행위</p>
                <p class="marker-hyphen">이용자는 서비스 이용 권한을 타인에게 양도하거나 담보로 제공할 수 없습니다.</p>
                <p class="marker-hyphen">
                  회사는 이용자가 본 약관 또는 관련 법령을 위반한 경우 서비스 이용을 제한하거나 계정 사용을 중단할 수
                  있습니다.
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 6조 (회사의 의무)</h2>
        <ul class="marker-dot">
          <li>회사는 안정적인 서비스 제공을 위해 노력합니다.</li>
          <li>개인정보 보호를 위한 보안 시스템을 구축하고 관련 법령을 준수합니다.</li>
          <li>이용자의 정당한 불만에 대해 신속히 처리하고 결과를 안내합니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 7조 (서비스의 중단 및 해지)</h2>
        <ul class="marker-dot">
          <li>약관 위반 또는 서비스 운영 방해 시 이용이 제한될 수 있습니다.</li>
          <li>국가 비상사태, 설비 장애 등 불가피한 사유로 서비스가 중단될 수 있습니다.</li>
          <li>이용자는 언제든지 서비스 이용을 중단하고 탈퇴할 수 있습니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 8조 (개인정보 보호)</h2>
        <ul class="marker-dot">
          <li>
            회사는 관련 법령에 따라 이용자의 개인정보를 보호하며, 개인정보 처리에 관한 사항은 개인정 보처리방침을
            따릅니다.
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 9조 (면책 조항)</h2>
        <ul class="marker-dot">
          <li>회사는 법령이 허용하는 범위 내에서 책임을 제한합니다.</li>
          <li>천재지변 등 불가항력으로 인한 서비스 중단에 대해 책임을 지지 않습니다.</li>
          <li>이용자의 귀책사유로 발생한 손해에 대해 책임을 지지 않습니다.</li>
          <li>서비스 이용 결과에 대한 기대 손익에 대해 책임을 지지 않습니다.</li>
          <li>이용자 간 또는 제3자와의 분쟁에 개입하지 않습니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 10조 (분쟁 해결)</h2>
        <ul class="marker-dot">
          <li>회사와 이용자는 분쟁 해결을 위해 성실히 협의합니다.</li>
          <li>협의로 해결되지 않을 경우 콘텐츠분쟁조정위원회에 조정을 신청할 수 있습니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 11조 (준거법 및 관할)</h2>
        <ul class="marker-dot">
          <li>본 약관은 대한민국 법을 준거법으로 합니다.</li>
          <li>분쟁에 대한 소송은 민사소송법상의 관할 법원에 제기합니다.</li>
        </ul>
      </div>
      <div class="last-txt">시행일 : 2025년 12월 22일</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.app-container {
  padding: 0 0 4rem;
}
.head-txt-wrap {
  padding: 1rem 0;
  strong {
    font-size: $font-size-psmall;
    font-weight: 500;
    display: block;
    margin-bottom: $size-xs;
  }
  p {
    font-size: $font-size-psmall;
    color: $color-gray-500;
  }
}
.marker-txt-wrap {
  .marker-dot {
    .inr {
      padding-bottom: $size-s;
      h3 {
        font-size: $font-size-psmall;
      }
      p {
        font-size: $font-size-psmall;
      }
    }
  }
  .last-txt {
    padding: 1rem 0;
    font-size: $font-size-psmall;
  }
}
</style>
